@let isExperianCompany = isExperianCompany$ | async;

<div class="menu-container align-items-center py-2 px-3">
  <a
    class="mobile-menu-item layout-fr gap-1 bold text-12"
    [routerLink]="['/', paths.PLATFORM, paths.platform.DASHBOARD]"
    routerLinkActive="active">
    <shared-icon class="icon" icon="dashboard" width="1.25rem" height="1.25rem" />
    <span>{{ isExperianCompany ? "Status" : "Dashboard" }}</span>
  </a>
  <a
    class="mobile-menu-item layout-fr gap-1 bold text-12"
    [routerLink]="['/', paths.PLATFORM, paths.platform.PROPERTIES]"
    routerLinkActive="active">
    <shared-icon class="icon" icon="property" width="1.25rem" height="1.25rem" />
    <span>{{ isExperianCompany ? "Dashboard" : "Properties" }}</span>
  </a>

  @if (!isMobileApp) {
    <a
      *hasCompanyClientUiSettingsEnabled="showDocumentUploadKey"
      class="mobile-menu-item layout-fr gap-1 bold text-12"
      [routerLink]="['/', paths.PLATFORM, paths.platform.DOCUMENTS]"
      routerLinkActive="active">
      <shared-icon class="icon" icon="document" width="1.25rem" height="1.25rem" />
      <span>Documents</span>
    </a>
  }

  @if (isMobileApp) {
    <a
      class="mobile-menu-item layout-fr gap-1 bold text-12"
      [routerLink]="['/', paths.PLATFORM, paths.platform.MAB_ARTICLES]"
      routerLinkActive="active">
      <shared-icon class="icon" icon="document" width="1.25rem" height="1.25rem" />
      <span>Articles</span>
    </a>
  }
</div>
